import session from '../framework/utils/session-store';
import {cobraApi} from "../framework";

const storeParticipant = {
  namespaced: true,
  state: {
        firstName: null,
        lastName: null,
        participantId: null,
        employerId: null,
        address1: null,
        address2: null,
        ssn: null,
        dateOfBirth: null,
        gender: null,
        locationCode: null,
        city: null,
        state: null,
        zip: null,
        email: null,
        phone: null,
        cellPhone: null,
        phoneIsMobile: null,
        accountNumber: null,
        accountType: null,
        bankName: null,
        method: null,
        nickname: null,
        routingNumber: null,
        createdDate: null,
        terminationDate: null,
        isTerminated: false,
        cardProcessor: null,
        parentId: null,
        pendingActionItems: null,
        registration: null,
        firstDataAAID: null,
        firstDataMemberSequenceId : null,
        firstDataMpTableId: null,
        firstDataCovId: null,
        terminationWorkflowId: null,
        benefitTerminationDate: null,
        employmentStatusId: null,
        disableDebitCard: false,
        ready: false,
        terminationId: null,
    },
    getters: {
        fullName(state) { return state.firstName ? (state.firstName + " " + state.lastName) : null; },
        isWca(state) { return state.cardProcessor == 1; },
        isFirstData(state) { return state.cardProcessor == 2; },
        isTerminating(state) { return new moment(state.terminationDate).isAfter(moment()) ; },
        createdToday(state) {
          return !state.createdDate || moment(state.createdDate).isSame(moment(), 'day');
        }
    },
    actions: {
        async loadRegistrationDetails(context) {
            let data = await romeApi.get(`/participant/${context.state.participantId}/registration`);
            context.commit('setData', { registration: data });
        },
        async load(context, data) {
            if (context.state.participantId != data.participantId) {
                setReady(context, false);
            }

            let id = data.participantId;
            if (!id) return;
            if (context.state.participantId == data.participantId && !data.force) {
                setReady(context, true);
                return;
            }

            let [p, r, c, u] = await Promise.all([
                romeApi.get(`/participant/${id}/demographics`),
                romeApi.get(`/participant/${id}/reimbursement`),
                romeApi.get(`/participant/${id}/actionitem/pending`),
                romeApi.get(`/participant/${id}/registration`),
            ]);

            p.phone = formatters.phone(p.phone);
            p.cellPhone = formatters.phone(p.cellPhone);
            context.commit("setData", p);
            context.commit("setData", r);
            context.commit("setData", { pendingActionItems: c });
            context.commit("setData", { registration: u });
            
            setReady(context, true);
        },
        async update(context, data) {
            let id = context.state.participantId;
            if (!id) return;
            let postData = _.omit(context.state, "ready");
            _.assign(postData, data);

            if(typeof postData.email == 'string' && postData.email.trim() == '') postData.email = null;

            if(postData.cellPhone)
                postData.cellPhone = _.filter(postData.cellPhone.split(''), c => Number.isInteger(parseInt(c))).join('');

            if (data.method) {
                await romeApi.post(`/participant/${id}/reimbursement`, postData);
            } else {
                await romeApi.post(`/participant/${id}/demographics`, postData);
            }
            context.commit("setData", data);
        },
        async terminate(context, data) {
            let id = context.state.participantId;
            if (!id) return;
            await romeApi.post(`/participant/${id}/terminate`, data);
            context.commit("setData", data);
        },
        async reactivate(context, data){
            let id = context.state.participantId;
            if (!id) return;
            var result = await romeApi.post(`/participant/${id}/reactivate`);
            context.commit("setData", data);
            return result;
        },
        async loadAAID(context)
        {
            let id = context.state.participantId;
            if (!id) return;
            var result = await romeApi.get(`/participant/${id}/AAID`);
            context.commit("setAAID", result);
        },
        async setDisableDebitCard(context, disable) {
            let id = context.state.participantId;
            if (!id) return;
            if (disable) {
                await romeApi.post(`/participant/${id}/card/disable`)
            } else {
                await romeApi.post(`/participant/${id}/card/enable`);
            }
            context.commit("setData", { disableDebitCard: disable });
        },
        async updateName(context, data) {
            context.commit("setData", { firstName: data.firstName, lastName: data.lastName });
        }
    },
    mutations: {
        setData(state, data) {
            utils.copyCommonProperties(data, state);
        },
        setParticipantReady(state, value) {
            state.ready = value;
        },
        setAAID(state, value){
            state.firstDataAAID = value;
        }
    }
};

function setReady(context, value) {
    context.commit("setParticipantReady", value);
}

export default storeParticipant;



// WEBPACK FOOTER //
// ./src/participant/x-participant.js